import loadCss from "./loadCss";
import env from "../helpers/env/env";
export default function loadMinigameCss() {
  loadCss(env.name.toLowerCase(), env.url);
}